exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex;\r\n    flex: 1 1 auto;\r\n    background-color: #fff;\r\n    min-height: 0;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/content/content.component.css
// module id = 1857
// module chunks = 1